import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createBlock as _createBlock, mergeProps as _mergeProps, withCtx as _withCtx } from "vue"

import { reactive } from 'vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'RenderSelect',
  props: ['item'],
  setup(__props) {

const props = __props;

const state: any = reactive({
  options: [],
})


const setting = props.item.setting || [];

setting.forEach((item: any) => {
  state.options.push({
    label: item,
    value: item,
  });
});


return (_ctx: any,_cache: any) => {
  const _component_el_option = _resolveComponent("el-option")!
  const _component_el_select = _resolveComponent("el-select")!

  return (_openBlock(), _createBlock(_component_el_select, _mergeProps(_ctx.$attrs, {
    clearable: "",
    placeholder: " "
  }), {
    default: _withCtx(() => [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(state.options, (item) => {
        return (_openBlock(), _createBlock(_component_el_option, {
          key: item.value,
          label: item.label,
          value: item.value
        }, null, 8, ["label", "value"]))
      }), 128))
    ]),
    _: 1
  }, 16))
}
}

})